import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/markyctian/nes-design/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Explain } from 'docz';
import { Icon, Table } from '@components';
import { Props } from './config';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const TagVersion = makeShortcode("TagVersion");
const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "icon"
    }}>{`Icon`}</h2>
    <TagVersion component="Icon" mdxType="TagVersion" />
    <h2 {...{
      "id": "use-and-import"
    }}>{`Use and Import`}</h2>
    <Explain component="Icon" isCopyable mdxType="Explain" />
    <h2 {...{
      "id": "case"
    }}>{`Case`}</h2>
    <Playground __position={2} __code={'<Icon name=\"twitter\" />\n<Icon name=\"facebook\" />\n<Icon name=\"instagram\" />\n<Icon name=\"github\" />\n<Icon name=\"google\" />\n<Icon name=\"gmail\" />\n<Icon name=\"medium\" />\n<Icon name=\"linkedin\" />\n<Icon name=\"twitch\" />\n<Icon name=\"youtube\" />\n<Icon name=\"reddit\" />\n<Icon name=\"whatsapp\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Explain,
      Icon,
      Table,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="App Icon" mdxType="Playground">
  <Icon name="twitter" mdxType="Icon" />
  <Icon name="facebook" mdxType="Icon" />
  <Icon name="instagram" mdxType="Icon" />
  <Icon name="github" mdxType="Icon" />
  <Icon name="google" mdxType="Icon" />
  <Icon name="gmail" mdxType="Icon" />
  <Icon name="medium" mdxType="Icon" />
  <Icon name="linkedin" mdxType="Icon" />
  <Icon name="twitch" mdxType="Icon" />
  <Icon name="youtube" mdxType="Icon" />
  <Icon name="reddit" mdxType="Icon" />
  <Icon name="whatsapp" mdxType="Icon" />
    </Playground>
    <Playground __position={3} __code={'<Icon name=\"close\" />\n<Icon name=\"trophy\" />\n<Icon name=\"coin\" />\n<Icon name=\"heart\" />\n<Icon name=\"like\" />\n<Icon name=\"star\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Explain,
      Icon,
      Table,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Other Icon" mdxType="Playground">
  <Icon name="close" mdxType="Icon" />
  <Icon name="trophy" mdxType="Icon" />
  <Icon name="coin" mdxType="Icon" />
  <Icon name="heart" mdxType="Icon" />
  <Icon name="like" mdxType="Icon" />
  <Icon name="star" mdxType="Icon" />
    </Playground>
    <Playground __position={4} __code={'<Icon name=\"trophy\" size=\"large\" />\n<Icon name=\"trophy\" />\n<Icon name=\"trophy\" />\n<Icon name=\"trophy\" size=\"small\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Explain,
      Icon,
      Table,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Size" mdxType="Playground">
  <Icon name="trophy" size="large" mdxType="Icon" />
  <Icon name="trophy" mdxType="Icon" />
  <Icon name="trophy" mdxType="Icon" />
  <Icon name="trophy" size="small" mdxType="Icon" />
    </Playground>
    <Playground __position={5} __code={'<Text status=\"error\">\n  Provide custom Icon class to meet the needs of NES.CSS special Icon\n</Text>\n<Text status=\"error\">提供自定义 Icon 类，适应官方无规则的 Icon 需求</Text>\n<Icon customClass=\"nes-logo\" />\n<Icon customClass=\"nes-jp-logo\" />\n<Icon customClass=\"snes-logo\" />\n<Icon customClass=\"snes-jp-logo\" />\n<Icon customClass=\"nes-octocat animate\" />\n<Icon customClass=\"nes-smartphone\" />\n<Icon customClass=\"nes-phone\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Explain,
      Icon,
      Table,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Injection Class" mdxType="Playground">
  <Text status="error" mdxType="Text">Provide custom Icon class to meet the needs of NES.CSS special Icon</Text>
  <Text status="error" mdxType="Text">提供自定义 Icon 类，适应官方无规则的 Icon 需求</Text>
  <Icon customClass="nes-logo" mdxType="Icon" />
  <Icon customClass="nes-jp-logo" mdxType="Icon" />
  <Icon customClass="snes-logo" mdxType="Icon" />
  <Icon customClass="snes-jp-logo" mdxType="Icon" />
  <Icon customClass="nes-octocat animate" mdxType="Icon" />
  <Icon customClass="nes-smartphone" mdxType="Icon" />
  <Icon customClass="nes-phone" mdxType="Icon" />
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <>
  {[Props.icon, Props.icons].map(({
        columns,
        data,
        footer
      }) => <div style={{
        marginTop: 20
      }}>
        <Table theme="dark" columns={columns} data={data} footer={() => <div style={{
          height: 60,
          borderTop: '4px solid white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
            {footer}
            </div>} mdxType="Table" />
      </div>)}
    </>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      